import { createConfig } from 'fuels';

export default createConfig({
  {{#if (isDefined workspace)}}
  workspace: '{{workspace}}',
  {{else}}
    {{#if (isDefined contracts)}}
  contracts: [
      {{#each contracts}}
        '{{this}}',
      {{/each}}
  ],
    {{/if}}
    {{#if (isDefined predicates)}}
  predicates: [
      {{#each predicates}}
        '{{this}}',
      {{/each}}
  ],
    {{/if}}
    {{#if (isDefined scripts)}}
  scripts: [
      {{#each scripts}}
        '{{this}}',
      {{/each}}
  ],
    {{/if}}
  {{/if}}
  output: '{{output}}',
  {{#if (isDefined forcPath)}}
  forcPath: '{{forcPath}}',
  {{/if}}
  {{#if (isDefined fuelCorePath)}}
  fuelCorePath: '{{fuelCorePath}}',
  {{/if}}
  {{#if (isDefined autoStartFuelCore)}}
  autoStartFuelCore: {{autoStartFuelCore}},
  {{/if}}
  {{#if (isDefined fuelCorePort)}}
  fuelCorePort: {{fuelCorePort}},
  {{/if}}
});

/**
 * Check the docs:
 * https://docs.fuel.network/docs/fuels-ts/fuels-cli/config-file/
 */
